module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-none",
    staticStyle: {
      "top": "44px"
    }
  }, [_c('bo-map', {
    ref: "map",
    attrs: {
      "map-key": "be8b0ba056f729296b31543b1fcd8787",
      "address": "杭州"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "layout-bottom "
  }, [_c('button', {
    staticClass: "btn btn-lg btn-block btn-square btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58ccda7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bo-map/demo.vue
// module id = 252
// module chunks = 6